import { get, deserialize, serialize } from '@immobiliare-labs/querystring';
import gtxConstants from '@getrix/common/js/gtx-constants';

export let isEmpty = (data) => Object.values(data).every((x) => x === null || x === '' || typeof x === 'undefined');

export let setQueryString = (url, data) => {
    let qs = !isEmpty(data) ? `?${serialize(data)}` : '';
    history.replaceState({}, '', `${url}${qs}`);
};

export let deleteQueryString = (url) => {
    history.replaceState({}, '', url);
};

export let getQueryString = () => {
    if (!location.href) {
        return;
    }

    return deserialize(get(location.href));
};

export let removeQueryStringParam = (paramName) => {
    if (!location.href) {
        return;
    }

    let paramsObj = deserialize(get(location.href));

    if (paramsObj[paramName]) {
        delete paramsObj[paramName];
    }

    setQueryString(location.href, paramsObj);
};

export let areEqualShallowCompare = (a, b) => {
    if (!a && !b) {
        return true;
    }

    if (Object.keys(a).length !== Object.keys(b).length) {
        return false;
    }

    for (let key in b) {
        if (!(key in a)) {
            return false;
        }

        if (a[key] !== b[key]) {
            return false;
        }
    }

    return true;
};

export let removeObjectProps = (obj, props) => {
    Object.keys(obj).forEach((key) => {
        if (props.includes(key)) {
            delete obj[key];
        }
    });

    return obj;
};

export const isDescendant = (parent, child) => {
    let node = child ? child.parentNode : null;

    while (node != null) {
        if (node == parent) {
            return true;
        }

        node = node.parentNode;
    }

    return false;
};

export const resolveAsset = (asset) =>
    fetch(`/bundles/manifest.json?${Date.now()}`)
        .then((res) => res.json())
        .then((manifest) => manifest[asset]);

export const groupBy = (key) => (array) =>
    array.reduce((objectsByKeyValue, obj) => {
        const value = obj[key];
        objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
        return objectsByKeyValue;
    }, {});

export const mediaAssetsVersioning = (url, append = false, encode = false) => {
    if (!url) {
        return;
    }

    const version = `v=${gtxConstants('MEDIA_ASSETS_VERSION')}`;
    let separator = append ? '&' : '?';

    if (encode) {
        separator = separator.replace(/&/g, '&amp;');
    }

    return `${url}${separator}${version}`;
};

/**
 * Cleans an object by returning a copy which contains only valid keys;
 * optionally removes keys where value is just an empty string
 * @param {Record} objectToClean - original object to clean
 * @param {Array<string>} validKeys - array of valid keys
 * @param {Array<string>} cleanEmptyStringsFrom - these keys will be removed if their value is equal to an empty string
 */
export const sanitizeObject = ({ objectToClean, validKeys, cleanEmptyStringsFrom = [] }) => {
    if (!validKeys || !Array.isArray(validKeys)) {
        return objectToClean;
    }

    const newObject = {};
    const keys = Object.keys(objectToClean);

    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if (validKeys.includes(key)) {
            if (
                !cleanEmptyStringsFrom.includes(key) ||
                (cleanEmptyStringsFrom.includes(key) && objectToClean[key] !== '')
            ) {
                newObject[key] = objectToClean[key];
            }
        }
    }
    return newObject;
};
